<template>
  <div class="fixed inset-0 flex items-center justify-center z-50">
    <div class="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
    <div
      class="bg-gray-800 text-white rounded-lg shadow-xl border border-gray-700 p-5 max-w-md z-10 w-full mx-4 md:w-auto transform transition-all duration-300 scale-100"
    >
      <div class="flex justify-between items-start mb-5">
        <div class="flex items-center">
          <div class="bg-red-500 p-2 rounded-lg mr-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 text-white"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <h3 class="text-xl font-medium text-white">
            Prijavi korisnika
            <span class="text-red-400">{{ reportedUsername }}</span>
          </h3>
        </div>
        <button
          @click="$emit('close')"
          class="text-gray-400 hover:text-gray-300 transition-colors bg-gray-700 hover:bg-gray-600 rounded-full p-1.5"
        >
          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      </div>

      <div class="mb-4">
        <label class="block text-sm text-gray-300 mb-2">Razlog prijave:</label>
        <div class="grid grid-cols-2 gap-2">
          <button
            type="button"
            @click="reportData.reason = 'spam'"
            class="p-2 rounded-lg text-sm transition-colors"
            :class="
              reportData.reason === 'spam'
                ? 'bg-red-600 text-white'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            "
          >
            <div class="flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 mr-1"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
              Spam
            </div>
          </button>
          <button
            type="button"
            @click="reportData.reason = 'harassment'"
            class="p-2 rounded-lg text-sm transition-colors"
            :class="
              reportData.reason === 'harassment'
                ? 'bg-red-600 text-white'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            "
          >
            <div class="flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 mr-1"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M2.94 6.412A2 2 0 002 8.108V16a2 2 0 002 2h12a2 2 0 002-2V8.108a2 2 0 00-.94-1.696l-6-3.75a2 2 0 00-2.12 0l-6 3.75zm2.615 2.423a1 1 0 10-1.11 1.664l5 3.333a1 1 0 001.11 0l5-3.333a1 1 0 00-1.11-1.664L10 11.798 5.555 8.835z"
                  clip-rule="evenodd"
                />
              </svg>
              Uznemiravanje
            </div>
          </button>
          <button
            type="button"
            @click="reportData.reason = 'fake_profile'"
            class="p-2 rounded-lg text-sm transition-colors"
            :class="
              reportData.reason === 'fake_profile'
                ? 'bg-red-600 text-white'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            "
          >
            <div class="flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 mr-1"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                  clip-rule="evenodd"
                />
              </svg>
              Lažni profil
            </div>
          </button>
          <button
            type="button"
            @click="reportData.reason = 'other'"
            class="p-2 rounded-lg text-sm transition-colors"
            :class="
              reportData.reason === 'other'
                ? 'bg-red-600 text-white'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            "
          >
            <div class="flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4 mr-1"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-.464 5.535a1 1 0 10-1.415-1.414 3 3 0 01-4.242 0 1 1 0 00-1.415 1.414 5 5 0 007.072 0z"
                  clip-rule="evenodd"
                />
              </svg>
              Drugo
            </div>
          </button>
        </div>
      </div>

      <div class="mb-5">
        <label for="reportDescription" class="block text-sm text-gray-300 mb-2"
          >Opis problema:</label
        >
        <textarea
          id="reportDescription"
          v-model="reportData.description"
          class="w-full p-3 bg-gray-700 border border-gray-600 rounded-lg text-white text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors"
          rows="3"
          placeholder="Detaljno opišite problem koji imate sa ovim korisnikom..."
          :class="{ 'border-red-500 ring-1 ring-red-500': validationError }"
        ></textarea>
        <div class="flex justify-between mt-1">
          <p
            v-if="validationError"
            class="text-sm text-red-400 flex items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 mr-1"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"
              />
            </svg>
            {{ validationError }}
          </p>
          <p class="text-xs text-gray-400 ml-auto">
            {{ reportData.description.length }}/100 karaktera
          </p>
        </div>
      </div>

      <div class="flex justify-between space-x-3 mt-6">
        <button
          @click="$emit('close')"
          class="px-5 py-2.5 bg-gray-700 text-gray-300 rounded-lg hover:bg-gray-600 transition-colors font-medium"
        >
          Otkaži
        </button>
        <button
          @click="submitReport"
          class="px-5 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium flex items-center space-x-2"
          :disabled="isSubmitting"
        >
          <svg
            v-if="!isSubmitting"
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clip-rule="evenodd"
            />
          </svg>
          <svg
            v-if="isSubmitting"
            class="animate-spin h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          <span>{{
            isSubmitting ? 'Slanje prijave...' : 'Prijavi korisnika'
          }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive, ref } from 'vue';

export default defineComponent({
  name: 'ReportModal',
  props: {
    reportedUserId: {
      type: String,
      required: true,
    },
    reportedUsername: {
      type: String,
      required: true,
    },
  },
  emits: ['close', 'report-submitted'],
  setup(props, { emit }) {
    const reportData = reactive({
      reason: 'fake_profile',
      description: '',
    });

    const validationError = ref('');
    const isSubmitting = ref(false);

    const submitReport = () => {
      // Validate form
      const descriptionLength = reportData.description.trim().length;

      if (descriptionLength === 0) {
        validationError.value = 'Opis problema je obavezan';
        return;
      }

      if (descriptionLength < 10) {
        validationError.value = 'Opis mora imati najmanje 10 karaktera';
        return;
      }

      if (descriptionLength > 100) {
        validationError.value = 'Opis ne sme biti duži od 100 karaktera';
        return;
      }

      validationError.value = '';
      isSubmitting.value = true;

      // Send report data to parent component
      emit('report-submitted', {
        ...reportData,
        reportedUserId: props.reportedUserId,
      });
    };

    return {
      reportData,
      validationError,
      isSubmitting,
      submitReport,
    };
  },
});
</script>
